var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContinuousProfiling = function SvgContinuousProfiling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 164,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2BD675",
    filter: "url(#Continuous_Profiling_svg__a)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 124.5,
    r: 14,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M73.787 124.5h-2.928l-2.196 6.587-4.391-13.175-2.196 6.588h-2.928"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Continuous_Profiling_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 71.5,
    r: 21,
    stroke: "#2BD675"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M30.47 65.719a2.656 2.656 0 0 1 3.833.208c1.003 1.15.913 2.92-.201 3.954l-9.047 8.4a2.653 2.653 0 0 1-3.632 0l-4.525-4.2c-1.114-1.035-1.204-2.805-.201-3.954a2.655 2.655 0 0 1 3.618-.388l.215.18 2.706 2.513z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M133.967 32.37C121.962 45.431 114.632 62.86 114.632 82c0 13.558 3.677 26.256 10.089 37.153a6.05 6.05 0 0 1 1.456-2.191c5.104-4.908 11.98-7.628 19.1-7.628h36.848c7.12 0 13.995 2.72 19.1 7.628 5.112 4.915 8.031 11.632 8.032 18.69v10.126a6.076 6.076 0 0 1-12.149 0v-10.126c0-3.679-1.517-7.258-4.3-9.935-2.793-2.686-6.634-4.235-10.683-4.236h-36.848c-4.048.001-7.884 1.551-10.677 4.236a6.05 6.05 0 0 1-4.23 1.692c13.436 17.028 34.256 27.959 57.63 27.959 20.215 0 38.519-8.176 51.789-21.401v11.61C225.669 157.093 207.641 164 188 164c-45.287 0-82-36.713-82-82 0-18.654 6.23-35.853 16.722-49.63zm95.525 48.15a6.074 6.074 0 0 1 8.127 9.029l-20.245 18.222a6.074 6.074 0 0 1-8.126 0l-10.126-9.11a6.073 6.073 0 0 1 7.647-9.42l.48.39 6.056 5.452zm-65.787-31.928c15.095 0 27.333 12.238 27.333 27.333s-12.237 27.333-27.333 27.334c-15.096 0-27.334-12.238-27.334-27.334.001-15.096 12.239-27.333 27.334-27.333m0 12.148c-8.386 0-15.185 6.799-15.185 15.185s6.799 15.185 15.185 15.185 15.185-6.799 15.185-15.185c-.001-8.386-6.799-15.184-15.185-15.185"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Continuous_Profiling_svg__a",
    width: 39,
    height: 39,
    x: 48,
    y: 105,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_726",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Continuous_Profiling_svg__b",
    width: 51,
    height: 51,
    x: 0,
    y: 46,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_726",
    stdDeviation: 2
  })))));
};
export default SvgContinuousProfiling;